import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import { VersionHistoryDialogViewComponent } from './component/dialog-components/version-history-dialog-view/version-history-dialog-view.component';
import { SharedWithMeComponent } from './component/shared-with-me/shared-with-me.component';
import {CheckInDialogComponent} from './component/dialog-components/check-in-dialog/check-in-dialog.component';
import {CheckOutDialogComponent} from './component/dialog-components/check-out-dialog/check-out-dialog.component';
import {FileDialogComponent} from './component/file-dialog/file-dialog.component';
import {FileNameCellViewerComponent} from './component/cell-components/file-name-cell-viewer/file-name-cell-viewer.component';
import {FileStoreIconViewComponent} from '@features/file-manager/component/file-store-icon-view/file-store-icon-view.component';
import {FileStoreRootViewComponent} from '@features/file-manager/component/file-store-root-view/file-store-root-view.component';
import {OrbitaxFileSelectorDialogComponent} from '@features/file-manager/component/dialog-components/orbitax-file-selector-dialog/orbitax-file-selector-dialog.component';
import {FileStoreLeftPanelComponent} from '@features/file-manager/component/file-store-left-panel/file-store-left-panel.component';
import {MoveItemDialogComponent} from '@features/file-manager/component/dialog-components/move-item-dialog/move-item-dialog/move-item-dialog.component';
import {SelectFieldsDialogComponent} from '@features/file-manager/component/select-fields-dialog/select-fields-dialog.component';
import {CopyToWorkspaceDialogComponent} from './component/dialog-components/copy-to-workspace-dialog/copy-to-workspace-dialog.component';
import {CreateEatWorkflowDialogComponent} from '@features/file-manager/component/dialog-components/create-eat-workflow-dialog/create-eat-workflow-dialog.component';
import {
  UploadOptionsDialogComponent
} from '@features/file-manager/component/dialog-components/upload-options-dialog/upload-options-dialog.component';
import {OrbitaxConnectViewComponent} from '@features/orbitax-connect/orbitax-connect-view/orbitax-connect-view.component';
import {ExcelFileTypeComponent} from '@features/file-manager/component/excel-file-type/excel-file-type.component';
import {EditFormulaExpressionComponent} from '@features/file-manager/component/edit-formula-expression/edit-formula-expression.component';
import { FileSelectFromDriveDialogComponent } from './component/dialog-components/file-select-from-drive-dialog/file-select-from-drive-dialog.component';

// @dynamic
export class FileManagerDynamicComponentHelper {
  static components: any;

  static create (): void {
  }

  public static init () {
    if (FileManagerDynamicComponentHelper.components) {
      return;
    }
    const components = {};

    components['SharedWithMeComponent'] = SharedWithMeComponent;
    components['CheckInDialogComponent'] = CheckInDialogComponent;
    components['CheckOutDialogComponent'] = CheckOutDialogComponent;
    components['VersionHistoryDialogViewComponent'] = VersionHistoryDialogViewComponent;
    components['FileDialogComponent'] = FileDialogComponent;
    components['FileNameCellViewer'] = FileNameCellViewerComponent;
    components['FileStoreIconViewComponent'] = FileStoreIconViewComponent;
    components['FileStoreRootViewComponent'] = FileStoreRootViewComponent;
    components['OrbitaxFileSelectorDialogComponent'] = OrbitaxFileSelectorDialogComponent;
    components['MoveItemDialogComponent'] = MoveItemDialogComponent;
    components['FileStoreLeftPanelComponent'] = FileStoreLeftPanelComponent;
    components['SelectFieldsDialogComponent'] = SelectFieldsDialogComponent;
    components['CopyToWorkspaceDialogComponent'] = CopyToWorkspaceDialogComponent;
    components['CreateEatWorkflowDialogComponent'] = CreateEatWorkflowDialogComponent;
    components['UploadOptionsDialogComponent'] = UploadOptionsDialogComponent;
    components['OrbitaxConnectViewComponent'] = OrbitaxConnectViewComponent;
    components['ExcelFileTypeComponent'] = ExcelFileTypeComponent;
    components['EditFormulaExpressionComponent'] = EditFormulaExpressionComponent;
    components['FileSelectFromDriveDialogComponent']= FileSelectFromDriveDialogComponent;
    FileManagerDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static register(key: string, component: any) {
    FileManagerDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
  public static getComponentArray (): any[] {
    FileManagerDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(FileManagerDynamicComponentHelper.components).forEach(key => {
      componentArray.push(FileManagerDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
